import { TableCard } from 'app/components'
import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { AtendimentosListHeader } from './components/header/AtendimentosListHeader'
import { AtendimentosTable } from './table/AtendimentosTable'

const AtendimentoList = () => {
  return (
    <TableCard>
      <AtendimentosListHeader />
      <AtendimentosTable />
    </TableCard>
  )
}

export const AtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <AtendimentoList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
